import { None } from "../../misc/option";
export class BaseInteraction {
    constructor() {
        this.name = 'base';
        this.removed = true;
        this.state = {
            interactions: [],
            enter_context: None.instance(),
            exit_context: None.instance(),
            data: {}
        };
        this._help_message = '';
    }
    get geometric() { return false; }
    get interactions() { return this.state.interactions; }
    get help_message() { return this._help_message; }
    set help_message(v) { this._help_message = v; }
    get enter_context() { return this.state.enter_context; }
    set enter_context(val) { this.state.enter_context = val; }
    get exit_context() { return this.state.exit_context; }
    set exit_context(val) { this.state.exit_context = val; }
    set(key, value) {
        this.state.data[key] = value;
    }
    get(key) {
        if (Object.keys(this.state.data).includes(key))
            return this.state.data[key];
        return null;
    }
    init() {
        this.removed = false;
    }
    remove() {
        if (this.removed)
            return;
        this.state.interactions = [];
        this.removed = true;
    }
    format_number_string(number) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
}
